import { MessageDescriptor } from 'react-intl';

import { CalledVia } from 'protocol/model/dto_base_pb';

import { organizationApiKeysMessages as messages } from './i18n';

export const viaLabels: Partial<Record<CalledVia, MessageDescriptor>> = {
  [CalledVia.CalledViaClient]: messages.viaClient,
  [CalledVia.CalledViaPartnerAPI]: messages.viaPartnerApi,
  [CalledVia.CalledViaMLPipelines]: messages.viaMlPipelines,
};
